<template>
  <div class="about">
    
  <!-- <img src="@/assets/SetoKaiba-DL.png"/> -->
  </div>
</template>



